/* eslint-disable-next-line import/prefer-default-export */
export const Domain = Object.freeze({
  HOME: 'Home',
  ORGANIZATIONS: 'Organizations',
  PROBLEMS: 'Problems',
  PROFILE: 'Profile',
  TEAMS: 'Teams',
});
